
export default function FruitHeightsNeighborhoods() {
  const neighborhoods = [
    {
      name: 'Nicholls Park Area',
      description: 'Established residential neighborhoods near Nicholls Park where we provide fast water damage restoration and emergency flood cleanup services.',
      icon: 'ri-park-line'
    },
    {
      name: 'Oak Hills',
      description: 'Scenic hillside homes in Oak Hills with unique drainage challenges, where our team delivers expert water damage and storm restoration services.',
      icon: 'ri-landscape-line'
    },
    {
      name: 'Mountain Road Corridor',
      description: 'Properties along the Mountain Road area, where we address hillside water intrusion, flooding, and storm damage with rapid emergency response.',
      icon: 'ri-road-map-line'
    },
    {
      name: 'East Fruit Heights',
      description: 'Upper hillside estates in East Fruit Heights with stunning views, where we handle water damage, mold remediation, and fire restoration.',
      icon: 'ri-home-4-line'
    },
    {
      name: 'Fruit Heights Estates',
      description: 'Premier residential community with custom homes requiring specialized restoration care and attention to detail for every project.',
      icon: 'ri-building-line'
    },
    {
      name: 'West Fruit Heights',
      description: 'Growing residential communities in West Fruit Heights near the I-15 corridor with modern homes we proudly serve around the clock.',
      icon: 'ri-community-line'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            Fruit Heights Neighborhoods We Serve
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            Fast water damage restoration response throughout all Fruit Heights areas
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {neighborhoods.map((neighborhood, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-5 md:p-8 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <div className="w-11 h-11 md:w-14 md:h-14 bg-sky-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className={`${neighborhood.icon} text-xl md:text-2xl text-sky-600`}></i>
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{neighborhood.name}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{neighborhood.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
